/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/components/export/order-export.component';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/services/uploadService';
const styles_OrderExportComponent:any[] = ([] as any[]);
export const RenderType_OrderExportComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_OrderExportComponent,data:{}});
export function View_OrderExportComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'text-center']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['Please wait...'])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'div',[['class',
          'spinner-container']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),0,'div',[['class','spinner']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' ']))],(null as any),(null as any));
}
export function View_OrderExportComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'order-export',
      ([] as any[]),(null as any),(null as any),(null as any),View_OrderExportComponent_0,
      RenderType_OrderExportComponent)),i0.ɵdid(4308992,(null as any),0,i1.OrderExportComponent,
      [i2.ActivatedRoute,i3.UploadService,i0.Renderer2],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const OrderExportComponentNgFactory:i0.ComponentFactory<i1.OrderExportComponent> = i0.ɵccf('order-export',
    i1.OrderExportComponent,View_OrderExportComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9leHBvcnQvb3JkZXItZXhwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0L29yZGVyLWV4cG9ydC5jb21wb25lbnQudHMuT3JkZXJFeHBvcnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwidGV4dC1jZW50ZXJcIj5QbGVhc2Ugd2FpdC4uLjwvZGl2PiA8ZGl2IGNsYXNzPVwic3Bpbm5lci1jb250YWluZXJcIj4gPGRpdiBjbGFzcz1cInNwaW5uZXJcIj48L2Rpdj4gPC9kaXY+IiwiPG9yZGVyLWV4cG9ydD48L29yZGVyLWV4cG9ydD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBeUIsbURBQW9CO1VBQUEsUUFBQztVQUFBO1VBQUEsZ0JBQStCLHNDQUFDO1VBQUE7VUFBQSwwREFBMkI7VUFBQTs7O29CQ0F6RztNQUFBO3FDQUFBLFVBQUE7TUFBQTs7UUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/export/order-export.component.ngfactory.ts